import axios from '@/libs/axios'

const API_BASE_URL = '/periodos'

export default {
  // Obtener todos los períodos
  async getAll() {
    try {
      const response = await axios.get(API_BASE_URL)
      return response.data
    } catch (error) {
      console.error('Error fetching periods:', error)
      throw error
    }
  },

  // Obtener un período por ID
  async getById(id) {
    try {
      const response = await axios.get(`${API_BASE_URL}/${id}`)
      return response.data
    } catch (error) {
      console.error('Error fetching period:', error)
      throw error
    }
  },

  // Crear un nuevo período
  async create(periodData) {
    try {
      const response = await axios.post(API_BASE_URL, periodData)
      return response.data
    } catch (error) {
      console.error('Error creating period:', error)
      throw error
    }
  },

  // Actualizar un período
  async update(id, periodData) {
    try {
      const response = await axios.put(`${API_BASE_URL}/${id}`, periodData)
      return response.data
    } catch (error) {
      console.error('Error updating period:', error)
      throw error
    }
  },

  // Eliminar un período (soft delete)
  async delete(id) {
    try {
      const response = await axios.delete(`${API_BASE_URL}/${id}`)
      return response.data
    } catch (error) {
      console.error('Error deleting period:', error)
      throw error
    }
  },

  // Obtener períodos activos
  async getActive() {
    try {
      const response = await axios.get(`${API_BASE_URL}/active`)
      return response.data
    } catch (error) {
      console.error('Error fetching active periods:', error)
      throw error
    }
  }
}